/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsUserCouponHistory,
    ControlcenterMelcoModelsUserCouponHistoryFromJSON,
    ControlcenterMelcoModelsUserCouponHistoryFromJSONTyped,
    ControlcenterMelcoModelsUserCouponHistoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsUserCouponHistory>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory
     */
    list: Array<ControlcenterMelcoModelsUserCouponHistory>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory {
    return ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsUserCouponHistoryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistoryToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsUserCouponHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsUserCouponHistoryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


